/**
 * The Cloud Functions region.
 *
 * Must match the region the functions are deployed to (`functions/src/shared/
 * config.js`) and the Firestore location. If the client asks for a region the
 * functions are not in, every callable fails with an opaque CORS or 404 error
 * that looks nothing like a configuration mistake.
 *
 * Kept in its own module rather than in `environment.js` because it is a fixed
 * architectural fact, not an environment variable: all three environments deploy
 * to London for UK data residency.
 */
export const REGION = "europe-west2";
